import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { ReactComponent as ChevronRightIcon } from "../../../assets/images/btn-right-aero.svg";
import { FiX } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import {
  getViewProfile,
  updateProfile,
} from "../../../redux/slices/profileSlice";
import { activityStart, activityEnd } from "../../../redux/slices/trackActivitySlice";

const ContractSecondDocumentModal = ({
  show,
  onHide,
  documentFile,
  onSave,
}) => {
  // const [file, setFile] = useState(documentFile || null);
  // const [fileUrl, setFileUrl] = useState(null);
  // const [secondFile, setSecondFile] = useState(null);
  // const [secondFileUrl, setSecondFileUrl] = useState(null);
  // const [uploadError, setUploadError] = useState(null); // Add local error state
  // const dispatch = useDispatch();
  // const store = useSelector((state) => state.profile);

  // useEffect(() => {
  //   if (documentFile) {
  //     setFile(documentFile);
  //     if (documentFile instanceof File) {
  //       setFileUrl(URL.createObjectURL(documentFile));
  //     } else if (typeof documentFile === "string") {
  //       setFileUrl(documentFile);
  //     }
  //   } else {
  //     setFile(null);
  //     setFileUrl(null);
  //   }
  // }, [documentFile]);

  // const handleSecondFileChange = (e) => {
  //   if (e.target.files.length > 0) {
  //     const selectedFile = e.target.files[0];
  //     setSecondFile(selectedFile);
  //     if (selectedFile instanceof File) {
  //       setSecondFileUrl(URL.createObjectURL(selectedFile));
  //     }
  //   }
  // };

  // const handleSave = async () => {
  //   if (!secondFile) {
  //     setUploadError("Please select a file first");
  //     return;
  //   }

  //   // Clear previous errors
  //   setUploadError(null);

  //   try {
  //     const result = await dispatch(
  //       updateProfile({ file, secondFile })
  //     ).unwrap();

  //     console.log("Upload successful:", result);
  //     onSave(result);
  //     onHide();
  //   } catch (error) {
  //     console.error("Upload failed:", error);
  //     // Set error in local state instead of alert
  //     setUploadError(
  //       error.message || error.toString() || "Upload failed. Please try again."
  //     );
  //   }
  // };

  // const onSubmit = () => {
  //   if (store?.profileItem?.data?.full_name) {
  //     const formData = new FormData();
  //     formData.append("name", store.profileItem.data.full_name || "");
  //     if (file) formData.append("doc_one", file);

  //     dispatch(updateProfile(formData));
  //   }
  // };

  // return (
  //   <Modal
  //     show={show}
  //     onHide={onHide}
  //     centered
  //     size="md"
  //     dialogClassName="custom-modal profile-other-details-modal"
  //   >
  //     <Modal.Header>
  //       <h5 className="modal-title">Upload Contract Document</h5>
  //       <Button className="close-btn" onClick={onHide}>
  //         <FiX size={24} />
  //       </Button>
  //     </Modal.Header>

  //     <Modal.Body>
  //       <Form.Group className="form-group file-input">
  //         <div>
  //           <Form.Control type="file" onChange={handleSecondFileChange} />
  //           <Form.Label className="col-file-label">Select file</Form.Label>
  //         </div>
  //         {secondFile && (
  //           <p className="uploaded-file-name">{secondFile.name}</p>
  //         )}
  //       </Form.Group>

  //       {/* Display upload error or Redux error */}
  //       {(uploadError || error) && (
  //         <div className="alert alert-danger mt-2">{uploadError || error}</div>
  //       )}

  //       <div className="buttons text-center mt-3">
  //         <Button
  //           variant="primary"
  //           onClick={handleSave}
  //           disabled={!secondFile || loading} // Fix: Check secondFile
  //         >
  //           {loading ? "Uploading..." : "Save"}{" "}
  //           <ChevronRightIcon className="button-icon" />
  //         </Button>
  //       </div>
  //     </Modal.Body>
  //   </Modal>
  // );
  const [file, setFile] = useState(documentFile || null);
  const [fileUrl, setFileUrl] = useState(null);
  const dispatch = useDispatch();
  const store = useSelector((state) => state.profile);
  useEffect(() => {
    if (documentFile) {
      setFile(documentFile);

      if (documentFile instanceof File) {
        setFileUrl(URL.createObjectURL(documentFile));
      } else if (typeof documentFile === "string") {
        setFileUrl(documentFile);
      }
    } else {
      setFile(null);
      setFileUrl(null);
    }
  }, [documentFile]);

  const handleFileChange = (e) => {
    if (e.target.files.length > 0) {
      const selectedFile = e.target.files[0];
      setFile(selectedFile);

      //  Only createObjectURL if a valid file exists
      if (selectedFile instanceof File) {
        setFileUrl(URL.createObjectURL(selectedFile));
      }
    }
  };

  const onSubmit = () => {
    if (store?.profileItem?.data?.full_name) {
      const formData = new FormData();
      formData.append("name", store.profileItem.data.full_name || "");
      if (file) formData.append("doc_two", file);

      dispatch(updateProfile(formData));
    }
  };

  useEffect(() => {
    if (store?.actionFlag === "PROFILE_UPDT_SCS") {
      onHide();
    }
  }, [dispatch, store?.actionFlag]);

  const handleViewDocument = () => {
    //  check if fileUrl exists before opening
    if (fileUrl) {
      window.open(fileUrl, "_blank");
    } else {
      alert("⚠️ No document uploaded yet.");
    }
  };

  useEffect(() => {
    if (!show) return;

    // Modal opened — start a tracking session
    dispatch(activityStart({ page_name: "CHANGE_CONTRACT_DOCUMENT", platform: "web" }));

    return () => {
      // Modal closed — end the session (duration recorded in seconds)
      dispatch(activityEnd({ page_name: "CHANGE_CONTRACT_DOCUMENT" }));
    };
  }, [show, dispatch]);
  useEffect(() => {
    if (show) {
      // dispatch(getViewProfile());
    }
  }, [show, dispatch]);
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="md"
      dialogClassName="custom-modal profile-other-details-modal"
    >
      <Modal.Header>
        {/* <Modal.Title>Upload Contract Document</Modal.Title> */}
        <h5 className="modal-title">Upload Contract Document</h5>
        <Button className="close-btn" onClick={onHide}>
          <FiX size={24} />
        </Button>
      </Modal.Header>

      <Modal.Body>
        <Form.Group className="form-group file-input">
          <div>
            <Form.Control type="file" onChange={handleFileChange} />
            <Form.Label className="col-file-label">Select file</Form.Label>
          </div>
          {file && <p className="uploaded-file-name">{file.name || file}</p>}
        </Form.Group>

        {/* {fileUrl && (
            <Button
              variant="outline-primary"
              size="sm"
              className="mt-2"
              onClick={handleViewDocument}
            >
              View Document
            </Button>
          )} */}
        <div className="buttons text-center">
          <Button
            variant="primary"
            onClick={onSubmit}
            disabled={store?.isLoading || !file}
          >
            {store?.isLoading ? "Saving..." : "Save"}{" "}
            <ChevronRightIcon className="button-icon" />
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ContractSecondDocumentModal;
